const URL = {
    MAIN: "/", //메인페이지
    MAIN_NEW: "/main", //메인페이지
    INDEX: "/index", //메인인덱스   

    ERROR: "/error", //로그인

    //ABOUT
    ABOUT: "/about", //사이트소개   

    //PRODUCTS
    PRODUCTS: "/products", //사업영역
    PRODUCTS_OLD: "/products_old", //사업영역
    //CONTACT
    CONTACT: "/contact", // 개발문의
    PRIVATE: "/private", //개인정보처리 방침

}
export default URL;